import request from "@/request";

/**
 * @description 查询产品分类
 * @returns 返回 Axios请求 实例
 */
export const queryProductCategoryList = () => {
  return request({
    url: "/product/category/list",
    method: "get",
  });
};

/**
 * @description 查询产品分类下的所有产品
 * @param {Number}categoryId  产品分类 id
 * @returns 返回 Axios请求 实例
 */
export const queryProductDetail = (categoryId: Number) => {
  return request({
    url: `/product/list/${categoryId}/1/20`,
  });
};
